import { isBlankString } from 'libs/end-to-end/src/generic';
import { isUnknownString } from 'libs/end-to-end/src/generic';
import { DataFieldType } from 'libs/end-to-end/src/data-row';
import { DataRow } from 'libs/end-to-end/src/data-row';

export const sortFilterValues = (values: string[]): string[] => {
  const type = fieldTypeForList(values);
  return values.sort((a, b) => sortResultForField(a, b, type));
};

export const sortResultForField = (
  aField: string,
  bField: string,
  fieldType: DataFieldType,
) => {
  const aIsBlank = aField ? isBlankString(aField) : true;
  const bIsBlank = bField ? isBlankString(bField) : true;

  const aIsUnknown = isUnknownString(aField);
  const bIsUnknown = isUnknownString(bField);

  // sort and put the empty values at the end
  // for example if aField is an empty value and bField is not an empty value, bField should appear first
  // Unknown values should appear at the end, after empty values
  if (aIsUnknown && !bIsUnknown) {
    return 1;
  }

  if (!aIsUnknown && bIsUnknown) {
    return -1;
  }

  if (aIsUnknown && bIsUnknown) {
    return 0;
  }

  if (aIsBlank && !bIsBlank) {
    return 1;
  }

  if (!aIsBlank && bIsBlank) {
    return -1;
  }

  if (aIsBlank && bIsBlank) {
    return 0;
  }

  if (fieldType === 'number') {
    const aNumber = Number(aField);
    const bNumber = Number(bField);

    if (aNumber < bNumber) {
      return -1;
    }

    if (aNumber > bNumber) {
      return 1;
    }

    return 0;
  }

  if (aField < bField) {
    return -1;
  }

  if (aField > bField) {
    return 1;
  }

  return 0;
};

// These two functions are the same, but one is optimized for CSV rows and the other is for a list of values.
// Be careful if you modify one of them, you will need to modify the other one as well.
export const fieldTypeForField = (
  rows: DataRow[],
  fieldIndex: number,
): DataFieldType => {
  let allNumbers = true;

  for (const row of rows) {
    const value = row[fieldIndex];

    if (isBlankString(value) || isUnknownString(value)) {
      continue;
    }

    if (isNaN(Number(value))) {
      allNumbers = false;
      break;
    }
  }

  if (allNumbers) {
    return 'number';
  }

  return 'string';
};

export const fieldTypeForList = (items: string[]): DataFieldType => {
  let allNumbers = true;

  for (const value of items) {
    if (isBlankString(value) || isUnknownString(value)) {
      continue;
    }

    if (isNaN(Number(value))) {
      allNumbers = false;
      break;
    }
  }

  if (allNumbers) {
    return 'number';
  }

  return 'string';
};
